import AddressInputYandex from './AddressInputYandex.vue';

import {Vue, VueVendor} from 'ui.vue';

/** Глобальная регистрация компонента */
(window.Vue || Vue).component('address-input-yandex', AddressInputYandex);